import digitalData from 'digital-data';
import { getState } from '../analytics-state';
import { PIP_SUB_CONTENT, INTERACTION, COLLECTION } from '../constants';

export const mediaGallery = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@MEDIA-GALLERY/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@MEDIA-GALLERY/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });
  window.LIFE_CYCLE_EVENT_BUS.on('@@MEDIA-GALLERY/THUMBNAIL_CLICK', (payload) => {

    if (window.isDebugMode) {
      console.log('%c @@MEDIA-GALLERY/THUMBNAIL_CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  const determineClickTarget = (target) => {
    if (target.match(/hotspots/i)) return 'hotspots';
    if (target.match(/image/i)) return 'image';
    if (target.match(/video/i)) return 'video';
    if (target.match(/threesixty/i)) return 'threesixty';
    if (target.match(/augmented_reality/i)) return 'ar';
    return target;
  };

  window.LIFE_CYCLE_EVENT_BUS.on('media-gallery.click', ({ output = {} }) => {
    // perform ddo stuff for carousel click
    const { pageType = null } = getState() || {};
    const isCollection = pageType === COLLECTION;

    if (!isCollection) {
      const {
        target = '', section, component, position
      } = output;

      const ddoEvent = {
        eventInfo: {
          eventName: PIP_SUB_CONTENT
        },
        category: {
          primaryCategory: INTERACTION
        },
        subContent: {
          section,
          component,
          target: determineClickTarget(target),
          position
        }
      };
      digitalData.event.push(ddoEvent);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('media-gallery.thumbnail_click', ({ output }) => {
    const { pageType = null } = getState() || {};
    const isCollection = pageType === COLLECTION;

    const {
      eventName,
      primaryCategory
    } = output;
    const thdAnalyticsEvent = {
      eventInfo: {
        eventName
      },
      category: {
        primaryCategory
      },
    };

    if (isCollection) {
      thdAnalyticsEvent.eventInfo.eventName = 'collection image';
    }

    digitalData.event.push(thdAnalyticsEvent);
  });

};
